import React, { useEffect } from 'react';
import { Button, Form, Input, InputNumber, Modal, Radio } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { IDataModal } from '@/interfaces/dataModal';
import { IBusinessUnit } from '@/interfaces/business-unit';
import { addBusinessUnit, editBusinessUnit } from '@/adapters/business-unit';

interface IProps {
  dataModal?: IDataModal<IBusinessUnit>;
  handleOk: () => void;
  handleCancel: () => void;
}

const BusinessUnitModal = ({ dataModal, handleOk, handleCancel }: IProps) => {
  const [form] = Form.useForm();
  const mutations = useMutation({
    mutationFn: async (data: IBusinessUnit) =>
      dataModal?.id
        ? await editBusinessUnit(data)
        : await addBusinessUnit(data),
    mutationKey: ['fetchUnit'],
    onSuccess: data => {
      if (data?.status != 200) {
        throw new Error();
      } else {
        handleOk();
      }
    },
    onError: error => {
      console.log(error);
    },
  });

  const handleUpdate = async () => {
    form
      .validateFields()
      .then(async (values: IBusinessUnit) => {
        values.id = Number(dataModal?.id || 0);
        values.mediaId = dataModal?.item?.mediaId;
        values.signatureMediaId = dataModal?.item?.signatureMediaId;
        await mutations.mutateAsync(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  const onReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    if (dataModal?.id) {
      form.setFieldsValue(dataModal?.item);
    }
  }, [dataModal?.id]);

  return (
    <Modal
      title={dataModal?.id ? `แก้ไข BU ${dataModal?.item?.name}` : 'เพิ่ม BU'}
      open={dataModal?.open}
      onOk={() => handleUpdate()}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ยกเลิก
        </Button>,
        <Button
          key="submit"
          type="primary"
          form="unit"
          loading={mutations.isPending}
          onClick={handleUpdate}
        >
          บันทึก
        </Button>,
      ]}
      afterClose={onReset}
    >
      <div className="flex w-full">
        <Form
          form={form}
          name="unit"
          onFinish={handleUpdate}
          layout="vertical"
          className="w-full"
        >
          <Form.Item
            label="ชื่อ"
            name="name"
            rules={[{ required: true, message: 'ระบุชื่อ BU' }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item<IBusinessUnit>
            label="Below Threshold  Mail TO"
            name="safetyMailTo"
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item<IBusinessUnit>
            label="Below Threshold  Mail CC"
            name="safetyMailCc"
          >
            <Input.TextArea
              rows={3}
              size="large"
              placeholder="cc คั่นด้วย , "
            />
          </Form.Item>
          <Form.Item<IBusinessUnit> label="Threshold" name="threshold">
            <InputNumber
              size="large"
              placeholder="Stock Expired Day"
              min={0}
              className="w-full"
              suffix={'%'}
            />
          </Form.Item>
          <Form.Item<IBusinessUnit> label="Adjust  Mail TO" name="adjustMailTo">
            <Input size="large" />
          </Form.Item>
          <Form.Item<IBusinessUnit> label="Adjust  Mail CC" name="adjustMailCc">
            <Input.TextArea
              rows={3}
              size="large"
              placeholder="cc คั่นด้วย , "
            />
          </Form.Item>
          <Form.Item<IBusinessUnit>
            label="Adjust Dif Percentage"
            name="safetyStockPercent"
          >
            <InputNumber
              size="large"
              placeholder="Stock Dif Percentage"
              min={0}
              className="w-full"
              suffix={'%'}
            />
          </Form.Item>
          <Form.Item<IBusinessUnit>
            label="Stock Expired Day"
            name="stockExpiredDate"
          >
            <InputNumber
              size="large"
              placeholder="Stock Expired Day"
              min={0}
              className="w-full"
              suffix={'Days'}
            />
          </Form.Item>
          <Form.Item<IBusinessUnit>
            label="SafetyStock Auto Send"
            name="isSafetyAutoSend"
          >
            <Radio.Group
              options={[
                { value: true, label: 'Auto' },
                { value: false, label: 'None' },
              ]}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default BusinessUnitModal;
